import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CompanyService } from '../services/company/company.service';



@Injectable({
  providedIn: 'root'
})
export class CompanyIdInterceptor implements HttpInterceptor {
  constructor(private companyService: CompanyService) {}
  
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.companyService.currentCompany) {
      request = request.clone({
        setHeaders: {
          'x-company-id': this.companyService.currentCompany,
        },
      });
    }

    return next.handle(request);
  }
}
